<!--- View principal - Responsável Por renderizar a barra lateral e superior. --->

<template>
  <div class="w-full h-screen flex">
    <Sidebar />
    <div
      class="flex flex-column w-full hidden-on-print"
      style="margin-left: 72px; max-width: calc(100% - 75px)"
    >
      <NavbarLayout />
      <!--
        O MIOLO é o scroller da aplicação, não o documento.

        A navbar NÃO é `position: fixed` (o `fixed-top` do NavbarLayout é uma
        prop que o b-navbar não tem — vira atributo HTML, nunca classe): ela
        ocupa 72px em fluxo, e é por isso que este bloco vale
        `calc(100vh - 72px)`. Sem `overflow` aqui a altura fixa não segurava
        nada: conteúdo mais alto vazava, o DOCUMENTO rolava e levava a navbar
        junto. Com o scroll de volta ao miolo, a navbar e a sidebar ficam
        paradas sem precisar sair do fluxo (o que colidiria com o z-index dos
        b-modal).

        `overflow: auto` nos dois eixos de propósito: telas mais largas que a
        coluna hoje empurram o scroll horizontal do documento; aqui ele fica
        contido. É este elemento (`$refs.mainScroll`) que NewAttendance e
        CustomAppointmentView já usam como alvo de scroll.
      -->
      <div
        class="w-full when-print bg-neutral-100"
        ref="mainScroll"
        style="height: calc(100vh - 72px); overflow: auto"
      >
        <!--
          `key` só no detalhe do laudo (/laudo-medico/): o anterior/próximo troca
          só os parâmetros, e sem a key o Vue reaproveitaria a instância sem
          rodar de novo o `mounted`. Nas demais rotas a key é undefined.
        -->
        <router-view :key="routerViewKey" />
      </div>
    </div>

    <CsatDeferredPromptMount />

    <StockAlertsReact
      :open="showWarehouseNotifications"
      :clinicId="warehouseClinicId"
      :notifications="notifications"
      @close="showWarehouseNotifications = false"
      @navigate="goToWarehouse"
    />

    <v-checkterm-modal
      :checkedPolicy="checkedPolicy"
      :checkedTerm="checkedTerm"
    />
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    CsatDeferredPromptMount: () =>
      import('@/components/Csat/CsatDeferredPromptMount.vue'),
    Sidebar: () => import('@/modules/designSystem/layouts/Sidebar'),
    NavbarLayout: () => import('@/modules/designSystem/layouts/NavbarLayout'),
    // Modal de avisos migrado para React (86ajutbqz) — o wrapper monta o
    // módulo de react-apps/warehouse/stock-alerts.
    StockAlertsReact: () => import('@/views/Warehouse/StockAlertsReact.vue'),
    'v-checkterm-modal': () => import('@/components/General/CheckTermModal')
  },
  async mounted() {
    this.eventHub.$on('attendance-opened', attendanceData => {
      if (
        attendanceData !== null &&
        typeof attendanceData.patient_id !== 'undefined' &&
        typeof attendanceData.id !== 'undefined'
      ) {
        const attendancePath =
          '/pacientes/' +
          attendanceData.patient_id +
          '/consulta/' +
          attendanceData.id
        if (this.$router.currentRoute.path !== attendancePath) {
          this.$router.push(attendancePath).catch(err => {
            // Handle navigation errors silently
            if (err.name !== 'NavigationDuplicated') {
              console.warn('Navigation error:', err)
            }
          })
        }
      }
    })
    this.getWarehouseNotifications()
    this.getCheckTerms()

    setTimeout(() => {
      window.Beamer && !window.Beamer.initialized && window.Beamer.init()
    }, 3000)
  },
  data() {
    return {
      notifications: [],
      showWarehouseNotifications: false,
      warehouseClinicId: '',
      routePath: window.location.pathname,
      checkedTerm: true,
      checkedPolicy: true,
      url: window.location.host
    }
  },
  computed: {
    routerViewKey() {
      const path = this.$route?.path || ''
      return path.startsWith('/laudo-medico/') ? path : undefined
    }
  },
  methods: {
    getWarehouseNotifications() {
      const clinic = JSON.parse(localStorage.getItem('clinic'))
      this.warehouseClinicId = clinic.id
      this.api
        .getWarehouseNotifications(clinic.id)
        .then(({ data }) => {
          if (data.length) {
            this.notifications = data
            this.showWarehouseNotifications = true
          }
        })
        .catch(err => {
          console.log('Error loading warehouse notifications', err)
        })
    },

    /**
     * Navegação dos avisos: o módulo React emite o caminho, quem navega é o
     * Vue. Mantém o window.location.href do componente antigo — a aba de
     * destino lê o filtro da query na montagem, então precisa recarregar.
     */
    goToWarehouse(path) {
      this.showWarehouseNotifications = false

      if (!path) return

      if (this.$route.path.indexOf(path.split('?')[0]) === -1) {
        window.location.href = path
        return
      }

      // Já está na tela de destino: troca só a query, sem recarregar a página.
      this.$router.replace(path).catch(() => {})
    },
    getCheckTerms() {
      this.api
        .checkTerms()
        .then(({ data }) => {
          this.checkedTerm = data.checkedTerm
          this.checkedPolicy = data.checkedPolicy
          if (!this.checkedTerm || !this.checkedPolicy) {
            this.$bvModal.show('check-term-modal')
          }
        })
        .catch(err => {
          console.log('Error check terms', err)
        })
    }
  },
  watch: {
    $route(from) {
      this.routePath = from.path
    }
  }
}
</script>
